'use client';

import { useContext, useMemo } from 'react';

import { ProductType } from '@bytel/leviator';
import { CartContext } from '@bytel/leviator/react';

import { fetchSinglePlan } from '@services/products';

import { useQuery } from '@tanstack/react-query';

export function useFetchSinglePlan(planId?: string) {
    const { cart } = useContext(CartContext);

    const planToFetch = useMemo(() => {
        let planToFetch: string;
        if (planId) {
            planToFetch = planId;
        } else {
            planToFetch =
                cart?.journeys
                    ?.flatMap((journey) => journey.products)
                    .find((product) => product.isType(ProductType.MAIN_MOBILE_OFFER))?.gencode ?? '';
        }

        return planToFetch;
    }, [planId, cart]);

    const mobilePlanQuery = useQuery({
        queryKey: ['mobilePlan', planToFetch],
        queryFn: () => fetchSinglePlan(planToFetch, null),
        enabled: Boolean(planToFetch),
    });

    return {
        isLoading: mobilePlanQuery.isFetching,
        mobilePlanDetailed: mobilePlanQuery.data,
    };
}
